<template>
    <div style="padding:10px 20px">
        <span style="font-size:20px">众包服务</span>
        <p style="font-size:14px;color:#666666;text-align:left;"><span style="margin-left:20px"></span>日日顺众包服务，旨在搭建社会化服务的共享平台，师傅可自由选择加入平台，为用户，提供就近到家的安装、维修、清洗、同城配送等服务，帮助师傅提供单量，并提供更多机会和保障，实现社会化师傅的价值。</p>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>

</style>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>

</style>